import { render, staticRenderFns } from "./DashboardWeekReservations.vue?vue&type=template&id=3b030e58&scoped=true&"
import script from "./DashboardWeekReservations.vue?vue&type=script&lang=js&"
export * from "./DashboardWeekReservations.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWeekReservations.vue?vue&type=style&index=0&id=3b030e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b030e58",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/DashboardWeekReservations.vue
// module id = null
// module chunks = 